import React from 'react';
import Typewriter from 'typewriter-effect';

const skills = [
  'Full-Stack Developer',
  'Graphic Designer',
  'UI/UX Designer',
  'Aspiring Data Scientist',
];

const TypewriterText: React.FC = () => {
  return (
    <div className="font-mono text-sm md:text-base">
      <span className="text-secondary">
        <Typewriter
          options={{
            strings: skills,
            autoStart: true,
            loop: true,
            deleteSpeed: 30,
            delay: 50,
            cursor: '▎',
            wrapperClassName: 'text-secondary font-semibold',
            cursorClassName: 'text-secondary',
          }}
        />
      </span>
    </div>
  );
};

export default TypewriterText;
